import React from 'react';
import {
    VStack,
    Spinner,
    IBoxProps
} from 'native-base';
import { useTheme } from '@springbig/shared';

interface ILoadingProps extends IBoxProps {
    isLoading: boolean
}

const Loading = ({ isLoading, ...props }: ILoadingProps) => {

    const {
        primary,
    } = useTheme();

    if (!isLoading) {
        return null;
    }

    return (
        <VStack
            zIndex={1}
            left={0}
            top={0}
            bottom={0}
            right={0}
            position={'absolute'}
            justifyContent={'center'}
            alignItems={'center'}
            {...props}
        >
            <Spinner
                size={'lg'}
                color={primary}
            />
        </VStack>
    );
};

export default Loading;
